import { render, staticRenderFns } from "./BragbarSlider.vue?vue&type=template&id=1af3b731&scoped=true&"
import script from "./BragbarSlider.vue?vue&type=script&lang=js&"
export * from "./BragbarSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af3b731",
  null
  
)

export default component.exports